import { render } from "./ExternalPatientChangeEmailOffcanvas.vue?vue&type=template&id=0954d8ce&scoped=true"
import script from "./ExternalPatientChangeEmailOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExternalPatientChangeEmailOffcanvas.vue?vue&type=script&lang=js"

import "./ExternalPatientChangeEmailOffcanvas.vue?vue&type=style&index=0&id=0954d8ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0954d8ce"]])

export default __exports__